var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { PageContentfulStore } from '../stores/page-contentful.store';
/**
 * Initialize {@link PageContentfulStore}: load "serviceTitanPage" contentful object by codeId
 * @param codeId The "serviceTitanPage" contentful entry codeId field value
 * @param include Maximum nesting depth
 */
export function useContentfulPage(codeId, include = 10) {
    const [pageContenfulStore] = useDependencies(PageContentfulStore);
    useEffect(() => {
        function initialize() {
            return __awaiter(this, void 0, void 0, function* () {
                yield pageContenfulStore.lazyInitialize({ codeId, include });
            });
        }
        initialize();
        return () => pageContenfulStore.destroy();
    }, [codeId, include, pageContenfulStore]);
}
//# sourceMappingURL=use-contentful-page.js.map